import successModal from "../../assets/images/app/allaya/success-modal-icon.svg";
import { AudioStatus, OnboardingSessionStatus } from "../../constants";

export const MODAL_CONTENT_CONFIG = {
    [AudioStatus.INACTIVE]: {
        modalTitle: "Update Audio",
        modalSubText: "Are you sure you want to Inactivate this audio?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: successModal
    },
    [AudioStatus.ACTIVE]: {
        modalTitle: "Update Audio",
        modalSubText: "Are you sure you want to Activate this audio?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: successModal
    },
    [OnboardingSessionStatus.INTRO]: {
        modalTitle: "Remove as Intro/Kick-Off",
        modalSubText: "Are you sure you want to mark this session as Regular?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: successModal
    },
    [OnboardingSessionStatus.REGULAR]: {
        modalTitle: "Mark as Intro/Kick-Off",
        modalSubText: "Are you sure you want to mark this session as an Intro/Kick-Off session?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: successModal
    }
};
